import React from "react"
import { Card, CardBody, Row, Col, Progress, Badge } from "reactstrap"

const UserEngagementMetrics = () => {
  // Dummy data for user engagement - replace with real API data
  const engagementData = {
    dailyActiveUsers: 8450,
    weeklyActiveUsers: 12350,
    monthlyActiveUsers: 15420,
    averageSessionTime: "12m 34s",
    bounceRate: 23.5,
    retentionRate: 76.8,
    engagementMetrics: [
      { metric: "Posts Created", value: 1250, change: "+15%", color: "primary" },
      { metric: "Comments", value: 3420, change: "+8%", color: "success" },
      { metric: "Likes/Reactions", value: 8950, change: "+22%", color: "info" },
      { metric: "Shares", value: 567, change: "+5%", color: "warning" }
    ],
    userBehavior: [
      { activity: "Content Creation", percentage: 85, users: 13087 },
      { activity: "Social Interaction", percentage: 72, users: 11102 },
      { activity: "Profile Updates", percentage: 45, users: 6939 },
      { activity: "Settings Changes", percentage: 28, users: 4318 }
    ],
    peakHours: [
      { time: "9:00 AM", activity: 92 },
      { time: "12:00 PM", activity: 88 },
      { time: "3:00 PM", activity: 76 },
      { time: "6:00 PM", activity: 95 },
      { time: "9:00 PM", activity: 82 }
    ]
  }

  return (
    <Card className="border-0 shadow-sm">
      <CardBody>
        <div className="d-flex align-items-center justify-content-between mb-4">
          <h4 className="card-title mb-0">User Engagement</h4>
          <Badge color="success" className="badge-soft">
            <i className="mdi mdi-trending-up me-1"></i>
            Trending Up
          </Badge>
        </div>

        {/* Active Users Overview */}
        <Row className="mb-4">
          <Col sm={4}>
            <div className="text-center p-3 bg-light rounded">
              <h4 className="text-primary mb-1">{engagementData.dailyActiveUsers.toLocaleString()}</h4>
              <p className="text-muted mb-0 font-size-13">Daily Active</p>
            </div>
          </Col>
          <Col sm={4}>
            <div className="text-center p-3 bg-light rounded">
              <h4 className="text-success mb-1">{engagementData.weeklyActiveUsers.toLocaleString()}</h4>
              <p className="text-muted mb-0 font-size-13">Weekly Active</p>
            </div>
          </Col>
          <Col sm={4}>
            <div className="text-center p-3 bg-light rounded">
              <h4 className="text-info mb-1">{engagementData.monthlyActiveUsers.toLocaleString()}</h4>
              <p className="text-muted mb-0 font-size-13">Monthly Active</p>
            </div>
          </Col>
        </Row>

        {/* Key Metrics */}
        <Row className="mb-4">
          <Col sm={6} md={3}>
            <div className="text-center">
              <h5 className="text-primary">{engagementData.averageSessionTime}</h5>
              <p className="text-muted mb-0 font-size-13">Avg. Session</p>
            </div>
          </Col>
          <Col sm={6} md={3}>
            <div className="text-center">
              <h5 className="text-warning">{engagementData.bounceRate}%</h5>
              <p className="text-muted mb-0 font-size-13">Bounce Rate</p>
            </div>
          </Col>
          <Col sm={6} md={3}>
            <div className="text-center">
              <h5 className="text-success">{engagementData.retentionRate}%</h5>
              <p className="text-muted mb-0 font-size-13">Retention</p>
            </div>
          </Col>
          <Col sm={6} md={3}>
            <div className="text-center">
              <h5 className="text-info">4.2/5</h5>
              <p className="text-muted mb-0 font-size-13">Satisfaction</p>
            </div>
          </Col>
        </Row>

        <Row>
          <Col md={6}>
            <h6 className="mb-3">Content Engagement</h6>
            {engagementData.engagementMetrics.map((metric, index) => (
              <div key={index} className="d-flex align-items-center justify-content-between mb-3">
                <div>
                  <span className="font-size-14">{metric.metric}</span>
                  <Badge color={metric.color} className="badge-soft ms-2">
                    {metric.change}
                  </Badge>
                </div>
                <h6 className="mb-0 text-primary">{metric.value.toLocaleString()}</h6>
              </div>
            ))}
          </Col>

          <Col md={6}>
            <h6 className="mb-3">User Activity Patterns</h6>
            {engagementData.userBehavior.map((behavior, index) => (
              <div key={index} className="mb-3">
                <div className="d-flex justify-content-between mb-1">
                  <span className="font-size-14">{behavior.activity}</span>
                  <span className="text-muted font-size-13">
                    {behavior.users.toLocaleString()} users
                  </span>
                </div>
                <Progress value={behavior.percentage} color="primary" className="progress-sm" />
                <small className="text-muted">{behavior.percentage}% participation</small>
              </div>
            ))}
          </Col>
        </Row>

        <div className="mt-4 pt-3 border-top">
          <h6 className="mb-3">Peak Activity Hours</h6>
          <div className="d-flex justify-content-between">
            {engagementData.peakHours.map((hour, index) => (
              <div key={index} className="text-center">
                <div className={`avatar-sm rounded-circle bg-primary d-flex align-items-center justify-content-center mb-2`}>
                  <span className="text-white font-size-12">{hour.activity}</span>
                </div>
                <small className="text-muted">{hour.time}</small>
              </div>
            ))}
          </div>
        </div>
      </CardBody>
    </Card>
  )
}

export default UserEngagementMetrics